<template>
  <div ref="seccionContadorRef" class="seccion-editorial-container">
    
    <!-- 1. MOÑO SUPERIOR FULL-WIDTH -->
    <div ref="monioRef" class="monio-full-width-wrapper">
      <br> <br> <br> <br>
    </div>

    <!-- 2. LAYOUT PRINCIPAL CENTRADO -->
    <div class="contenido-editorial-wrapper">

      <!-- BLOQUE DE TEXTO E INFORMACIÓN CENTRADO -->
      <div class="info-columna">
        
        <!-- TITULO EDITORIAL -->
        <div ref="headerTextRef" class="header-text-block">
          <h2 class="the-details-title">Almost Here</h2>
          <div ref="lineaGoldRef" class="linea-decorativa-gold"></div>
        </div>

        <!-- FRASE POÉTICA -->
        <div ref="fraseRef" class="frase-container">
          <p class="frase-linea">EVERY SECOND CLOSER</p>
          <p class="frase-linea">TO MY BIG DAY!</p>
        </div>

        <!-- TITULO CONTADOR -->
        <div ref="tituloContadorRef" class="titulo-contador">
          <span class="solo-text">Only</span>
          <span class="faltan-text">LEFT</span>
        </div>

        <!-- CONTADOR MINIMALISTA -->
        <div ref="gridNumerosRef" class="contador-limpio-grid">
          <div class="tiempo-item">
            <span class="numero">{{ dias }}</span>
            <span class="etiqueta">Days</span>
          </div>
          <div class="tiempo-item">
            <span class="numero">{{ horas }}</span>
            <span class="etiqueta">Hours</span>
          </div>
          <div class="tiempo-item">
            <span class="numero">{{ minutos }}</span>
            <span class="etiqueta">Minutes</span>
          </div>
          <div class="tiempo-item">
            <span class="numero">{{ segundos }}</span>
            <span class="etiqueta">Seconds</span>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ContadorEditorialLimpio',
  setup() {
    const seccionContadorRef = ref(null)
    const monioRef = ref(null)
    const headerTextRef = ref(null)
    const lineaGoldRef = ref(null)
    const fraseRef = ref(null)
    const tituloContadorRef = ref(null)
    const gridNumerosRef = ref(null)

    const dias = ref('00')
    const horas = ref('00')
    const minutos = ref('00')
    const segundos = ref('00')

    let timerId = null

    const iniciarCuentaAtras = () => {
      const fechaEvento = new Date('2026-12-05T16:00:00')
      
      const calcularTiempo = () => {
        const ahora = new Date()
        const dif = fechaEvento - ahora

        if (dif <= 0) {
          dias.value = horas.value = minutos.value = segundos.value = '00'
          if (timerId) clearInterval(timerId)
          return
        }

        dias.value = String(Math.floor(dif / (1000 * 60 * 60 * 24))).padStart(2, '0')
        horas.value = String(Math.floor((dif / (1000 * 60 * 60)) % 24)).padStart(2, '0')
        minutos.value = String(Math.floor((dif / (1000 * 60)) % 60)).padStart(2, '0')
        segundos.value = String(Math.floor((dif / 1000) % 60)).padStart(2, '0')
      }

      calcularTiempo()
      timerId = setInterval(calcularTiempo, 1000)
    }

    onMounted(() => {
      iniciarCuentaAtras()

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: seccionContadorRef.value,
          start: 'top 75%',
          toggleActions: 'play none none none'
        }
      })

      // 1. Moño superior cae suavemente con ligero rebote
      tl.fromTo(monioRef.value, 
        { opacity: 0, y: -40, scale: 0.95 },
        { opacity: 1, y: 0, scale: 1, duration: 1.1, ease: 'back.out(1.2)' }
      )

      // 2. Título "Falta Muy Poco" con revelado elegante de cortina (clipPath)
      .fromTo(headerTextRef.value, 
        { clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)', opacity: 0, y: 20 },
        { clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', opacity: 1, y: 0, duration: 1.1, ease: 'power3.inOut' },
        '-=0.7'
      )

      // 3. Línea dorada se expande desde el centro
      .fromTo(lineaGoldRef.value, 
        { scaleX: 0, opacity: 0 },
        { scaleX: 1, opacity: 0.7, duration: 0.8, ease: 'power2.out' },
        '-=0.4'
      )

      // 4. Frase poética aparece desde abajo con desenfoque fino
      .fromTo(fraseRef.value, 
        { opacity: 0, y: 25, filter: 'blur(6px)' },
        { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.9, ease: 'power2.out' },
        '-=0.5'
      )

      // 5. Título "Solo FALTAN"
      .fromTo(tituloContadorRef.value, 
        { opacity: 0, scale: 0.88, y: 15 },
        { opacity: 1, scale: 1, y: 0, duration: 0.8, ease: 'back.out(1.5)' },
        '-=0.4'
      )

      // 6. Números del contador escalonan su entrada flotante
      .fromTo(gridNumerosRef.value.children, 
        { opacity: 0, y: 25, scale: 0.9 },
        { opacity: 1, y: 0, scale: 1, duration: 0.6, stagger: 0.1, ease: 'back.out(1.4)' },
        '-=0.3'
      )
    })

    onUnmounted(() => {
      if (timerId) clearInterval(timerId)
    })

    return {
      seccionContadorRef,
      monioRef,
      headerTextRef,
      lineaGoldRef,
      fraseRef,
      tituloContadorRef,
      gridNumerosRef,
      dias,
      horas,
      minutos,
      segundos
    }
  }
}
</script>

<style scoped>
/* ==========================================
   1. CONTENEDOR GENERAL EDGE-TO-EDGE
   ========================================== */
.seccion-editorial-container {
  position: relative;
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  min-height: 60vh;
  background: radial-gradient(circle, #6d0a14 0%, #3e0409 100%);
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 48px;
}

/* ==========================================
   2. MOÑO SUPERIOR SIN MARGENES
   ========================================== */
.monio-full-width-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  z-index: 5;
  will-change: transform, opacity;
}

.monio-img {
  width: min(100%, 480px);
  height: auto;
  display: block;
  object-fit: contain;
}

/* ==========================================
   3. ESTRUCTURA Y COLUMNA CENTRADA
   ========================================== */
.contenido-editorial-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2vh 16px 0;
  box-sizing: border-box;
}

.info-columna {
  position: relative;
  z-index: 3;
  width: 100%;
  max-width: 550px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
}

/* ==========================================
   4. TIPOGRAFÍAS Y ESTILOS
   ========================================== */
.header-text-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5vh;
  will-change: transform, clip-path, opacity;
}

.the-details-title {
  font-family: 'ludovica', serif;
  font-size: clamp(2rem, 8vw, 3rem);
  color: #B08D57;
  font-weight: 400;
  margin: 0;
  line-height: 1.1;
  white-space: nowrap;
}

.linea-decorativa-gold {
  width: clamp(60px, 20vw, 110px);
  height: 1.5px;
  background: #B08D57;
  margin-top: 0.8vh;
  transform-origin: center;
  will-change: transform;
}

.frase-container {
  margin-bottom: 2vh;
  will-change: transform, opacity, filter;
}

.frase-linea {
  font-family: 'Playfair Display', serif;
  font-size: clamp(0.75rem, 3vw, 0.9rem);
  color: #B08D57;
  margin: 0;
  line-height: 1.5;
  font-weight: 600;
  letter-spacing: 0.12em;
}

.titulo-contador {
  margin-bottom: 2vh;
  will-change: transform, opacity;
}

.solo-text {
  font-family: 'ludovica', serif;
  font-size: clamp(1.5rem, 6vw, 2.2rem);
  color: #B08D57;
  display: block;
  line-height: 1;
}

.faltan-text {
  font-family: 'Playfair Display', serif;
  font-size: clamp(0.85rem, 3.8vw, 1.1rem);
  color: #B08D57;
  font-weight: 700;
  letter-spacing: 0.15em;
  display: block;
  margin-top: 0.2vh;
}

/* ==========================================
   5. CONTADOR GRID
   ========================================== */
.contador-limpio-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: clamp(12px, 4vw, 28px);
  width: 100%;
  max-width: 480px;
  justify-content: center;
}

.tiempo-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  will-change: transform, opacity;
}

.numero {
  font-family: 'Playfair Display', serif;
  font-size: clamp(1.8rem, 7vw, 2.6rem);
  font-weight: 600;
  color: #ffffff;
  line-height: 1;
}

.etiqueta {
  font-family: 'Playfair Display', serif;
  font-size: clamp(0.6rem, 2.3vw, 0.75rem);
  color: #B08D57;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  margin-top: 0.6vh;
  font-weight: 500;
}
</style>